<!-- 学院概况 -->
<template>
  <div class="introduce">
    <div class="header">
      <my-header></my-header>
    </div>
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <div class="swiper">
      <my-swiper></my-swiper>
    </div>
    <div class="article" style="height: 50px;">
      <my-article newsTitle="学院概况" newsType="" style="height: 430px;color:rgb(80, 150, 255);font-weight: bold;width: 56%;">
      </my-article>
    </div>
    <div class="articlecontent">
      {{ content1 }}
      {{ content2 }}
    </div>

    <div class="article" style="height: 50px;">
      <my-article newsTitle="友情链接" newsType="" style="height: 430px;color:rgb(80, 150, 255);font-weight: bold;width: 56%;">
      </my-article>
    </div>
    <div class="link" style="height: 150px;">
      <my-link></my-link>
    </div>
    <div class="footer" style="height: 100px;">
      <my-footer></my-footer>
    </div>
  </div>
</template>

<script>
import header from "../components/header/header.vue"
import navbar from "../components/navbar/navbar.vue"
import swiper from "../components/swiper/swiper.vue"
import article from "../components/article/article.vue"
import footer from "../components/footer/footer.vue"
import link from "../components/link/link.vue"
export default {
  components:{
    "my-header":header,
    "my-navbar":navbar,
    "my-swiper":swiper,
    "my-article":article,
    'my-footer':footer,
    "my-link":link,
  },
  data () {
    return {
      content1:"机械工程学院开设有机械设计与制造、数控技术、机械制造及自动化、模具设计与制造、智能控制技术、工业机器人技术等6个专业，专业设置对接先进制造业，服务武汉智能制造产业。机械设计与制造专业是国家优质校骨干专业、国家骨干校重点建设专业群专业、武汉市CAD/CAM技术实训基地建设专业；数控技术是国家骨干校重点建设专业群专业、“高等职业学校提升专业服务产业发展能力项目”建设专业；模具设计与制造专业是国家骨干校重点建设专业；机械制造及自动化专业是国家骨干校重点建设专业群专业、武汉市双一流精神重点建设专业群牵头专业、武汉市品牌专业、校级专创融合试点专业；工业机器人技术是教育部第三批现代学徒制试点专业、教育部中德先进职业教育合作项目试点专业；为了更好的服务武汉市战略性新兴产业高端装备制造领域发展，新增了智能控制技术专业。组建了工业机器人技术专业群，专业群被立项为省级高水平建设专业群。学院“机械设计与制造骨干专业建设”、“校企共建智能制造生产性实训基地”、“武汉智能制造技术协同创新中心”等三个优质校项目获得了教育部认定。学院入选了“湖北省产业工人培训示范基地”，成为湖北省示范基地之一，并获批为湖北省“世界技能大赛CAD机械设计赛项湖北省培训基地”。",
      content2:"学院工业机器人技术专业、数控技术专业分别获批为工业机器人应用编程、多轴数控加工两个“1+X”职业技能等级证书考核点、省级管理中心，新增了机械制造及自动化专业智能制造单元维护1+X考核点。学校作为工业机器人应用编程1+X职业技能等级证书的省级管理中心及试点院校，被证书评价组织赛育达评为全国“优秀考核管理中心”、“优秀试点院校”。"
    }
  }
}
</script>

<style  scoped>
.articlecontent{
  display: flex;
  margin: 0 auto;
  width: 55%;
  color:rgb(161, 160, 158);
  font-size: 18px;
}
.article{
  display: flex;
  justify-content: center;
}
.link{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/introduce.vue